













































































import { getMetricLabel, getValuesIdxByMetric } from "@/utils/chart";
import {
  HELP_PREFIX_FRACTION_REQUESTS,
  HELP_PREFIX_FRACTION_ITEMS,
  HELP_PREFIX_FRACTION_MEMORY,
} from "@/config/series";
import { Prefix } from "@/types/debug-mode";
import { SeriesPoint } from "@/types/common";
import { Unit } from "@/types/unit";
import { Issue, NotificationType } from "@/types/notification";
import hitRateStatus from "@/mixins/hit-rate-status";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class PrefixLastStats extends Mixins(hitRateStatus) {
  @Getter("debugMode/prefixLastStats") lastStats!: (prefixID: number) => SeriesPoint | null | false;

  @Getter("debugMode/prefixStatsSeriesColumns") columns!: (prefixID: number) => false | string[];

  @Getter("debugMode/prefixIssues") issues!: (prefixID: number) => { [propName: string]: Issue };

  @Prop({ required: true })
  prefix!: Prefix;

  helpPrefixFractionRequests = HELP_PREFIX_FRACTION_REQUESTS;

  helpPrefixFractionItems = HELP_PREFIX_FRACTION_ITEMS;

  helpPrefixFractionMemory = HELP_PREFIX_FRACTION_MEMORY;

  initialIssue: Issue = {
    type: NotificationType.DEFAULT,
    message: "",
    icon: "",
  };

  get unit() {
    return Unit;
  }

  get hrStatus() {
    return this.hitRateStatus(this.getStat("prefix_hit_rate"));
  }

  metricLabel(metricID: string): string {
    return getMetricLabel(metricID);
  }

  getStat(metricID: string) {
    const columns = this.columns(this.prefix.id);
    if (!columns) return false;

    const lastStats = this.lastStats(this.prefix.id);
    if (!lastStats) return false;

    const i = getValuesIdxByMetric(columns, metricID);
    return lastStats[i];
  }

  // TODO rename to getFormattedStat
  getValByMetric(metricID: string, unit?: Unit) {
    const val = this.getStat(metricID);

    if ((val === 0 || val) && typeof val === "number") {
      if (unit === Unit.PERCENT) {
        return `${(val * 100).toFixed()}${Unit.PERCENT}`;
      } else if (unit === Unit.PER_SECOND) {
        return `${val.toFixed(2)}${Unit.PER_SECOND}`;
      }
      return val.toFixed(2);
    }

    return val;
  }

  issue(ID: string) {
    if (this.issues(this.prefix.id)[ID]) {
      return this.issues(this.prefix.id)[ID];
    }
    return Object.assign({}, this.initialIssue);
  }
}
